/**
 * Helper functions for handling hierarchical categories
 */

/**
 * Extract main categories and subcategories from flat category list
 * @param {Array} categoryList - Flat list of categories with ">" separator
 * @returns {Object} - { mainCategories: [], categoryMap: {} }
 */
export const parseCategoryHierarchy = (categoryList) => {
  const mainCategories = new Set();
  const categoryMap = {}; // { mainCategory: [subcategories] }

  categoryList.forEach(cat => {
    if (cat.includes(' > ')) {
      const [main, sub] = cat.split(' > ').map(s => s.trim());
      mainCategories.add(main);
      
      if (!categoryMap[main]) {
        categoryMap[main] = [];
      }
      categoryMap[main].push(sub);
    } else {
      // Main category without subcategory
      mainCategories.add(cat);
      if (!categoryMap[cat]) {
        categoryMap[cat] = [];
      }
    }
  });

  return {
    mainCategories: Array.from(mainCategories).sort(),
    categoryMap
  };
};

/**
 * Get subcategories for a given main category
 * @param {string} mainCategory - The main category
 * @param {Object} categoryMap - Map of main categories to subcategories
 * @returns {Array} - List of subcategories
 */
export const getSubcategories = (mainCategory, categoryMap) => {
  return categoryMap[mainCategory] || [];
};

/**
 * Format category for display (combine if subcategory exists)
 * @param {string} category - Main category
 * @param {string} subcategory - Subcategory (optional)
 * @returns {string} - Formatted category string
 */
export const formatCategoryDisplay = (category, subcategory) => {
  if (subcategory) {
    return `${category} > ${subcategory}`;
  }
  return category;
};
